<template>
  <div v-if="fields.length" class="cc-prep border rounded px-3 py-2 mb-3 text-left">
    <div class="d-flex flex-wrap align-items-center">
      <span class="cc-section-title mr-3 my-1">
        {{ $t("lang.label.cold_call_script.prep_title") }}
      </span>
      <button
        v-for="field in fields"
        :key="field.key"
        type="button"
        class="btn btn-sm rounded-pill mr-2 my-1"
        :class="openKey === field.key ? 'btn-outline-primary active' : 'btn-outline-secondary'"
        :aria-expanded="openKey === field.key ? 'true' : 'false'"
        @click="toggle(field.key)"
      >
        {{ $t("lang.label.cold_call_script." + field.label) }}
      </button>
    </div>
    <div v-if="openField" class="cc-scroll border-top mt-2 pt-2" style="max-height: 260px">
      <p class="cc-text">{{ openField.value }}</p>
    </div>
  </div>
</template>

<script>
import "./coldCall.css";

const PREP_FIELDS = [
  { key: "cc_presentation", label: "presentation" },
  { key: "cc_campagne", label: "campagne" },
  { key: "cc_lexique", label: "lexique" },
  { key: "cc_rdv", label: "rdv" },
];

export default {
  name: "ColdCallPrepBar",
  props: {
    script: { type: Object, default: null },
  },
  data() {
    return { openKey: null };
  },
  computed: {
    fields() {
      if (!this.script) {
        return [];
      }
      return PREP_FIELDS.filter((f) => this.script[f.key]).map((f) => ({
        ...f,
        value: this.script[f.key],
      }));
    },
    openField() {
      return this.fields.find((f) => f.key === this.openKey) || null;
    },
  },
  watch: {
    script() {
      this.openKey = null;
    },
  },
  methods: {
    toggle(key) {
      this.openKey = this.openKey === key ? null : key;
    },
  },
};
</script>
